<template>
  <div
    class="d-flex text-no-wrap"
    :class="{
      alerta: documento.alerta_vencimento > 0,
      vencido: documento.alerta_vencimento == 3,
      twoLine: twoLine,
    }"
  >
    <div>
      <v-icon v-if="icon" class="mdi mdi-calendar-clock" small /> Validade:
      {{ dataValidade(documento) }}
    </div>
    <div v-if="documento.data_validade != ''" class="vencimento">
      <span v-if="documento.dias_vencimento < 0">
        (venceu há {{ documento.dias_vencimento * -1 }}
        {{ plural(documento.dias_vencimento * -1) }})
      </span>
      <span v-else>
        ({{
          documento.dias_vencimento > 0
            ? `vencerá em ${documento.dias_vencimento} ${plural(
                documento.dias_vencimento
              )}`
            : "vence hoje"
        }})
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["documento", "icon", "twoLine"],
  methods: {
    dataValidade() {
      if (this.documento.data_validade === "") return "-";
      return moment(this.documento.data_validade).format("DD/MM/YYYY");
    },
    plural(n) {
      return n > 1 ? "dias" : "dia";
    },
  },
};
</script>

<style>
.alerta {
  font-weight: bold;
  color: #f57f17;
}

.alerta .v-icon {
  color: inherit;
}

.vencido {
  color: #c62828 !important;
}

.twoLine {
  flex-direction: column;
}

.vencimento {
  margin-left: 4px;
}

.twoLine .vencimento {
  margin-left: 0px;
}
</style>
